/* eslint-disable @typescript-eslint/no-explicit-any */
import Select, { SelectProps } from "@mui/material/Select"
import { useCallback } from "react"
import { theme } from "src/providers/ThemeProvider"
import { ArrowDown } from "../Icons"
import Text from "../Text"

interface ISelectFieldProps<TValue = any> extends SelectProps<TValue> {
  options: Array<{
    value?: TValue
    label: string
    [key: string]: any
  }>
}

const SelectField = ({
  options,
  fullWidth = true,
  renderValue,
  placeholder,
  children,
  sx,
  ...rest
}: ISelectFieldProps) => {
  const onRenderValue = useCallback(
    (selected?: any) => {
      if (!selected) {
        return (
          <Text color={theme.palette.grey[400]} fontSize={16} lineHeight="21px">
            {placeholder}
          </Text>
        )
      }
      return renderValue ? renderValue(selected) : selected
    },
    [placeholder, renderValue]
  )

  return (
    <Select
      displayEmpty
      renderValue={onRenderValue}
      fullWidth={fullWidth}
      inputProps={{ "aria-label": "Without label" }}
      sx={{
        "& > fieldset": {
          border: "none",
        },
        "& > div": {
          padding: "12px",
          background: theme.palette.grey[200],
          borderRadius: 2,
        },
        "& > svg": {
          cursor: "pointer",
          position: "absolute",
          right: 15,
          transition: "0.5s",
        },
        ...{ ...sx },
      }}
      IconComponent={ArrowDown}
      {...rest}
    >
      {children}
    </Select>
  )
}

export default SelectField
